import { type JSX } from 'react/jsx-runtime';

export const ConfluenceCardIllustrationDark = (): JSX.Element => (
	<svg
		height="128"
		width="100%"
		fill="none"
		preserveAspectRatio="xMinYMin slice"
		role="presentation"
		viewBox="0 0 335 128"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path fill="#1558BC" d="M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v120H0V8Z" />
		<g clipPath="url(#clip0_8794_200011)">
			<path fill="#8FB8F6" d="M0 6a6 6 0 0 1 6-6h322a6 6 0 0 1 6 6v122H0V6Z" />
			<path fill="#1F1F21" d="m-4.475-5.002 339.116-.017-.01 193-339.115.017z" />
			<path
				fill="#303134"
				d="m12.018 46.95 303.724-.016v8l-303.725.015zM12.018 65.031l107-.005v8l-107 .005z"
			/>
			<path fill="#123263" d="m220.031 47.107 23.2.093-.032 7.56-23.2-.093z" />
			<path fill="#1558BC" d="m243.221 32.984 29.994.12-.054 12.883-29.994-.119z" />
			<path fill="#1558BC" d="m242.092 32.998 1.315.005-.089 21.858-1.315-.005.089-21.858Z" />
			<path fill="#CECFD2" d="m247.258 38.37 22.653.09-.01 2.52-22.654-.09z" />
			<g clipPath="url(#clip1_8794_200011)">
				<path
					fill="#1868DB"
					d="M12.02 16.4a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6l-.001 12a6 6 0 0 1-6 6h-12a6 6 0 0 1-6-6v-12Z"
				/>
				<path
					fill="#fff"
					d="M29.907 24.86c-4.039-1.953-5.218-2.245-6.92-2.244-1.997 0-3.698.83-5.219 3.165l-.25.381c-.204.315-.249.427-.249.561 0 .135.068.247.318.404l2.563 1.594c.137.09.25.135.363.135.137 0 .227-.068.363-.27l.409-.628c.635-.965 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.703-.247l1.271-2.784c.136-.314.046-.516-.272-.673ZM18.13 19.945c4.04 1.952 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.22-3.165l.249-.382c.204-.314.25-.426.25-.561 0-.135-.069-.247-.318-.404l-2.564-1.594c-.136-.09-.25-.134-.363-.134-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.635 0-1.384-.18-2.314-.63l-2.678-1.256c-.272-.135-.567-.067-.703.247l-1.27 2.783c-.137.314-.046.517.271.674Z"
				/>
			</g>
			<path fill="#303134" d="m44.492 18.398 62-.003v8l-62 .003z" />
			<path
				fill="#EED7FC"
				d="M0 0h49.796v49.907H0z"
				style={{
					mixBlendMode: 'multiply',
				}}
				transform="matrix(.99226 -.12352 .12645 .99205 204 91.6)"
			/>
			<path
				fill="#D8A0F7"
				d="m212.232 101.041 27.612-3.75.433 3.118-27.612 3.75zM213.102 107.275l20.512-2.785.433 3.117-20.512 2.785z"
			/>
			<path fill="#FFEFAE" d="m62.016 92.414 51.03-4.99 5.12 51.134-51.03 4.99z" />
			<path
				fill="#FFC716"
				d="m71.465 100.662 30.372-3.084.3 2.896-30.371 3.083zM72.068 106.453l34.366-3.49.3 2.896-34.365 3.49zM72.52 112.814l15.33-1.556.3 2.895-15.33 1.556z"
			/>
			<path fill="#D3F1A7" d="m138.314 86.17 49.63 4.065-4.18 49.732-49.63-4.065z" />
			<path
				fill="#6A9A23"
				d="M164.817 110.241c-.248-.043-.701-.828-1.206-.94-.114-.139.081-.304-.205-.372-.157.285-1.194-.292-1.619-.217-.176-.064-2.998.904-2.549.916-4.724 3.376-5.711-.613-9.189-2.075-2.514-1.211-4.037 2.181-6.478 1.505-.822-.505.468-.398.766-.506 1.51-.148 2.126-1.626 3.639-1.744 3.051-1.62 6.885 3.836 4.947 2.006.029.701 2.299 1.734 1.079.843 3.958 1.642 4.341-1.719 8.759-1.357.88-.146 3.093 2.406 2.055 1.938l.001.003ZM176.145 101.415c-5.705.605-9.649-2.35-15.497-.615-.193-.948-.788-2.162-1.813-2.257.854.086 2.034 2.614.785.886-.712-1.298-4.363-.055-1.571-.925-1.887.087-3.718 1.461-5.085 2.704-2.251 1.748-.368-1.822-1.743-3.793-1.953-2.743-9.011 3.47-7.694 3.574.904-.777 2.07-1.216 2.608-2.112 8.627-4.897 1.917 4.868 6.933 3.527 8.528-6.488 3.997-.373 8.713-.456 2.929-2.364 14.219 2.547 14.366-.533h-.002Z"
			/>
			<path fill="#1F1F21" d="m50.193 86.81 75.02-.004v15.771l-75.021.004z" />
			<path
				stroke="#303134"
				strokeWidth={1.87}
				d="M.935.935h75.008v15.774H.935z"
				transform="matrix(1.00017 -.00005 -.00005 .99982 49.258 85.875)"
			/>
			<path fill="#1F1F21" d="M125.214 86.806 277.37 86.8v16.127l-152.157.007z" />
			<path
				stroke="#303134"
				strokeWidth={1.87}
				d="M.935.935h152.13v16.13H.935z"
				transform="matrix(1.00017 -.00005 -.00005 .99982 124.279 85.871)"
			/>
			<path fill="#4C6B1F" d="m143.188 90.87 31.005-.002v7.998l-31.005.002z" />
			<path fill="#1F1F21" d="m50.19 102.937 75.022-.004-.001 15.771-75.021.004z" />
			<path
				stroke="#303134"
				strokeWidth={1.87}
				d="M.935.935h75.008v15.774H.935z"
				transform="matrix(1.00017 -.00005 -.00005 .99982 49.256 102.002)"
			/>
			<path fill="#1F1F21" d="m125.212 102.933 152.156-.008v16.127l-152.157.008z" />
			<path
				stroke="#303134"
				strokeWidth={1.87}
				d="M.935.935h152.13v16.13H.935z"
				transform="matrix(1.00017 -.00005 -.00005 .99982 124.277 101.998)"
			/>
			<path fill="#9E4C00" d="m157.945 106.996 50.008-.002v7.998l-50.008.003z" />
			<path fill="#1F1F21" d="m50.19 119.064 74.819-.004-.001 14.958-74.818.004z" />
			<path
				stroke="#303134"
				strokeWidth={1.87}
				d="M.935.935H75.74v14.961H.935z"
				transform="matrix(1.00017 -.00005 -.00005 .99982 49.256 118.129)"
			/>
			<path fill="#1F1F21" d="m125.01 119.06 152.155-.008v15.128l-152.157.007z" />
			<path
				stroke="#303134"
				strokeWidth={1.87}
				d="M.935.935h152.13v15.13H.935z"
				transform="matrix(1.00017 -.00005 -.00005 .99982 124.074 118.125)"
			/>
			<path fill="#803FA5" d="m194.176 122.621 40.007-.002v7.999l-40.007.002z" />
			<g fill="#CECFD2" clipPath="url(#clip2_8794_200011)">
				<path d="M149.183 117.864c-.245.284-.939-.081-.846-.44a8.085 8.085 0 0 1 .647-1.635c.399-.682.637-.778.867-1.255.422-.799.933-2.243 1.054-2.595.021-.053.038-.1.072-.146.027-.049.025-.002.064-.045.007-.012.017-.015.017-.031 0 0-.009-.013-.011-.022l-.013-.007a5.39 5.39 0 0 0-.13-.071 23.743 23.743 0 0 0-1.477-.626c-.951-.41-1.539-.66-1.847-.788-.721-.316-1.237-.623-1.712-.989-.261-.2.006-.834.333-.783a7.856 7.856 0 0 1 1.897.55c.28.121.947.197 1.791.524.14.052.27.124.39.214.345.237.744.464 1.116.652l.136.075c.081.029.149.066.22.097.156.069.305.135.444.204.286.124.541.232.756.326-.27.52-.417.818-.417.818l-1.732 3.302c-.361.687-.535 1.019-.644 1.217-.327.61-.632 1.062-.979 1.46l.004-.006Z" />
				<path d="M137.756 92.356c.814-.544 1.247.12.613.731-.875.905-1.72 1.915-2.519 3.386-.455.83-.703 1.37-.896 1.852-.198.479-.338.91-.442 1.553-.187 1.09-.131 2.587.171 3.856.134.637.368 1.208.54 1.673.219.451.389.802.486.992.069.11.134.227.193.339.189.418.781 1.541 1.878 2.683.53.589 1.227 1.124 1.973 1.615.763.459 1.591.873 2.444 1.108.586.209 1.142.296 1.641.401.506.06.953.112 1.35.137.798.028 1.385-.029 1.782-.077 1.883-.247 3.239-.751 4.533-1.361.693-.353 1.118.194.45.722-1.221.917-2.7 1.659-4.815 1.948-.8.092-2.572.473-4.99-.17-.384-.122-.778-.226-1.131-.419-1.564-.73-3.163-1.898-4.207-3.003a6.898 6.898 0 0 1-.7-.779c-.193-.251-.391-.448-.512-.652-.264-.386-.423-.61-.423-.61s-.056-.087-.158-.24c-.088-.161-.215-.4-.372-.687-.319-.578-.669-1.423-.942-2.378-.583-1.915-.529-4.302-.237-5.656.419-2.041.956-2.93 1.224-3.476.9-1.64 1.961-2.693 3.066-3.488Z" />
			</g>
		</g>
		<defs>
			<clipPath id="clip0_8794_200011">
				<path fill="#fff" d="M0 6a6 6 0 0 1 6-6h322a6 6 0 0 1 6 6v122H0V6Z" />
			</clipPath>
			<clipPath id="clip1_8794_200011">
				<path fill="#fff" d="M12.02 10.4h24l-.002 24h-24z" />
			</clipPath>
			<clipPath id="clip2_8794_200011">
				<path fill="#fff" d="m138.982 91.3-8.668 15.598 20.813 11.287 8.668-15.598z" />
			</clipPath>
		</defs>
	</svg>
);
